export default __webpack_public_path__ + "static/company_header-7caa81ac1f40abc4c630885aa8857331.jpg";